import { postReturningUserData } from 'auth/ReturningUserApiCalls';
import { SET_DATA } from 'helpers/Constants';
import { setNextPage, submitData } from 'reg_redesign/actions';

const checkRedirectAndSubmit = (callback) => {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_DATA,
      payload: {
        submitLoading: true
      }
    });

    await submitData(getState());

    try {
      const response = await postReturningUserData();
      if (response?.redirect_path) {
        if (response?.contact_id)
          window.postHeapAnalytic('identify', response.contact_id);
        window.location.href = response.redirect_path;
      } else {
        dispatch(setNextPage(callback));
        dispatch({
          type: SET_DATA,
          payload: {
            submitLoading: false
          }
        });
      }
    } catch (e) {
      dispatch(setNextPage(callback));
      dispatch({
        type: SET_DATA,
        payload: {
          submitLoading: false
        }
      });
    }
  };
};

export default checkRedirectAndSubmit;
